class MapData {
    constructor(activity, index) {
        this.activity = activity;
        this.index = index;
    }
}

export default MapData;